import type { SearchSuggestion } from './search-panel';

/**
 * A curated product: `name` is what the row shows until the live lookup replaces it with the catalog's
 * current name; `query` is the catalog search that finds it, matched to the entry by slug.
 */
export type PopularProduct = SearchSuggestion & { query: string };

// Figma "Popular Products", used by the header search panel and the no-results state on /search.
// A stand-in until search analytics (e.g. Algolia's popular searches) can supply the list.
//
// Matched by product slug, never by name, so renaming a product can't drop it from the list.
// Hardwired (name, image, price, link captured from the live catalog 1 Oct 2026) so the header panel
// renders them the instant it opens instead of waiting on eight lookups. usePopularProducts still
// refreshes each one in the background on first open, so a changed price, image or URL corrects
// itself and a product dropped from the catalog disappears. To change the list, edit it here.
export const POPULAR_PRODUCTS: PopularProduct[] = [
  {
    name: 'Express Level End Post',
    query: 'Express Level End Post',
    href: '/express-level-end-post/p/738548/',
    price: '$256.71',
    image:
      'https://assets.viewrail.com/image/upload/e_brightness:-3/e_brightness:-3/v1752860851/www_viewrail/products/express-level-end-post/express-level-end-post-738548-0.jpg',
  },
  {
    name: 'Express DriveTite - Level Cable Railing',
    query: 'Express DriveTite - Level Cable Railing',
    href: '/drivetite-tension-kit/p/896630/',
    price: '$13.62',
    image: 'https://assets.viewrail.com/image/upload/v1774616040/www_viewrail/products/drivetite-tension-kit/rnze6ksrqjfwvqsq0har.jpg',
  },
  {
    name: '3" Thick Stair Tread - Signature',
    query: '3" Thick Stair Tread - Signature',
    href: '/3-thick-stair-tread-signature/p/647635/',
    price: '$248.34',
    image: 'https://assets.viewrail.com/image/upload/v1776789165/Signature-White_Oak-3in_Thick_Tread_1.jpg',
  },
  {
    name: 'FLIGHT Discovery Kit',
    query: 'FLIGHT Discovery Kit',
    href: '/flight-discovery-kit/p/900023/',
    price: '$50.00',
    image:
      'https://assets.viewrail.com/image/upload/v1786471884/www_viewrail/products/FLIGHT-discovery-kit/FLIGHT-Discovery-Kit_00001.jpg',
  },
  {
    name: 'Express Level Line Post',
    query: 'Express Level Line Post',
    href: '/express-level-line-post/p/738549/',
    price: '$171.14',
    image:
      'https://assets.viewrail.com/image/upload/v1752853689/www_viewrail/products/express-level-line-post/express-level-line-post-738549.jpg',
  },
  {
    name: 'Signature DriveTite - Level Cable Railing',
    query: 'Signature DriveTite - Level Cable Railing',
    href: '/5-32-inch-drivetite-tension-kit/p/316777/',
    price: '$13.62',
    image: 'https://assets.viewrail.com/image/upload/v1774616740/mx9sbhyzagbtlmvdtz4p.jpg',
  },
  {
    name: '1/2" Ultra Clear Glass Panel - Base Rail System',
    query: '1/2" Ultra Clear Glass Panel - Base Rail System',
    href: '/1-2-ultra-clear-glass-panel-base-rail-system/p/938237/',
    price: '$30.24',
    image: 'https://assets.viewrail.com/image/upload/v1778169257/mxgnqffcsz5rwtaub1ht.png',
  },
  {
    name: 'Glass Panel Samples',
    query: 'Glass Panel Samples',
    href: '/glass-panel-samples/p/499603/',
    price: '$10.00',
    image:
      'https://assets.viewrail.com/image/upload/v1786476911/www_viewrail/products/glass-panel-samples/Glass%20Panel%20Samples.jpg',
  },
];

/** The product a link points at (its slug), which is stable across renames and variant changes. */
export const productSlugOf = (href: string) => href.split('/').filter(Boolean)[0];
